import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  DoDoNot,
  HazardTable,
} from './DocumentPage';

const PillarDrillDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Pillar Drill – RA & SSOW"
    documentHeading="Risk Assessment 04 & Safe System of Work: Pillar Drill"
    meta={[
      ['Document Reference', 'PVS-RAMS-PD-001'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Area / Location', 'Workshop'],
      ['Activity', 'Use of a pillar drill / pedestal drill'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Pillar Drill – RA & SSOW',
      documentReference: 'PVS-RAMS-PD-001',
      processActivity: 'Use of Pillar Drill',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Introduction">
      <Paragraph>
        There are a number of hazards present when using a pillar drill, for example eye injury
        caused by ejection of materials, entanglement with the rotating drill bit etc. resulting in
        cuts, sprains, strains etc. or electrocution / burns / fire from faulty electrics, wiring
        etc.
      </Paragraph>
    </Section>

    <Section number="2" title="Hazard Identification and Risk Assessment">
      <HazardTable
        columns={['Hazard Category', 'Hazards', 'Control Measures Already in Place', 'Additional Control Measures Required']}
        rows={[
          [
            'General Controls',
            [],
            [
              'Good housekeeping standards are maintained.',
              'The area is well ventilated.',
              'Appropriate lighting is provided in all areas.',
              'Pre-work creams and washing facilities are provided.',
            ],
            'None required.',
          ],
          [
            'Physical Hazards',
            [
              'Eye injury caused by ejection of materials.',
              'Entanglement with the rotating drill bit etc. resulting in cuts, sprains, strains etc.',
            ],
            [
              'Staff have been provided with sufficient information, instruction and training.',
              'Mandatory "Wear Eye Protection" sign is displayed. Impact resistant eye protection is provided and worn.',
            ],
            [
              'Operator guards need to be fitted to the drills to prevent contact with the rotating drill bit.',
              'Pillar and pedestal drills need to be fixed to the floor or work bench.',
              'Mandatory "Wear Eye Protection" sign is to be displayed.',
            ],
          ],
          [
            'Manual Handling',
            [
              'Musculoskeletal disorders from lifting, lowering, pushing, pulling or carrying load(s).',
              'Damage to feet, legs by dropping load(s).',
              'Cuts and other injuries from contact with sharp edges etc.',
            ],
            [
              'Mechanical lifting equipment is available, for example trolleys, forklifts, etc.',
              'Separate manual handling (general) risk assessment has been completed.',
            ],
            'None required.',
          ],
        ]}
      />
    </Section>

    <Section number="3" title="Safe System of Work">
      <DoDoNot
        doItems={[
          'Carry out a visual check of the equipment before use. Report any defects to your Manager or Supervisor.',
          'Wear impact resistant eye protection (standard spectacles are not adequate) when operating the drill.',
          'Take precautions against entanglement with moving parts by wearing tight fitting clothing, tying back long hair, removing loose jewellery, etc.',
          'Keep all guards and holding screws in place, tight and in good working order.',
          'CHECK that all persons are clear of the work area.',
          'CHECK that equipment is switched off before connecting it to the power supply.',
          'Allow fixed speed drills to reach full operating speed before applying them to a surface.',
          'Isolate the drill from the power supply before changing accessories, servicing or maintenance.',
          'Maintain the drill in good condition.',
          'Ensure the drill has been secured to a supporting structure e.g. work bench.',
          'Ensure the chuck is securely fastened to the spindle.',
          'Remove chuck keys and wrenches from the machine before switching on.',
          'Use clamps or a vice to secure the work-piece.',
          'Keep drill bits clean and sharp for the best and safest performance.',
          'Keep the working area clear of obstructions.',
          'Maintain correct balance and footing.',
        ]}
        doNotItems={[
          'Wear gloves when drilling.',
          'Drill materials containing asbestos.',
          'Operate the drill if it is damaged, guards are missing / damaged etc.',
          'Cover equipment air vents.',
          'Secure / hold the work-piece by hand.',
          'Leave the drill operating while unattended.',
          'Reach under or over the machine when it is operating.',
          'Wear loose fitting cuffs; loose fitting clothing; jewellery that could become entangled with the machine.',
          'Overreach.',
          'Touch or attempt to touch a revolving drill bit.',
          'Pull power plugs from sockets by the power cable.',
          'Exceed the rated capacity of the drill.',
          'Use the equipment in wet or damp conditions.',
          'Force the drill (it will do the job better and safer at the rate for which it is intended).',
          'Drill pieces of material that are too small to be securely held.',
        ]}
      />
    </Section>

    <Section number="4" title="Reminder">
      <Paragraph className="font-semibold">
        You have a duty not only to protect your own health and safety but also to ensure that your
        actions do not put others around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default PillarDrillDoc;
